import {
    ImageContainer,
    TextContainer,
    TextParagraph,
    WineContainer
} from "./content-wine.style";
import { LanguageContext } from "../../contexts/language.context";
import { useContext } from "react";

export const WineContent = () => {
    const { romanianLanguage } = useContext(LanguageContext);

    const text = romanianLanguage
        ? {
            title: "Dispunem de 7 tipuri de vin în vânzare:",
            subtitle: "Verduzzo d`Ori, prosecco, vinuri moldovenești, aromate, cu gust intens.",
            price: "1 litru vin italian - €2.40. 1 litru vin moldovenesc - €2.50"
        }
        : {
            title: "Disponiamo di 7 tipi di vino in vendita:",
            subtitle: "Verduzzo d`Ori, prosecco, vini moldavi, aromatici, dal gusto intenso.",
            price: "1 litro di vino italiano - €2.40. 1 litro di vino moldavo - €2.50"
        };

    return (
        <WineContainer id={"wine"}> 
            <ImageContainer>
                <TextContainer>
                    <TextParagraph>
                        <h1>{text.title}</h1>
                        <h3>{text.subtitle}</h3>
                        <h3>{text.price}</h3>
                    </TextParagraph>
                </TextContainer>
            </ImageContainer>
        </WineContainer>
    );
};